import React, { useEffect, useState } from 'react'
// import styles from "./styles.module.scss";
import { Report } from 'notiflix/build/notiflix-report-aio'
import { InputFieldText, FieldGroup, Field, SubmitButton, FormCard } from '../../reusable'

import { FormPartInterface, SaveValueInterface } from '../../../interfaces'
import { useClaimData, useUpdateClaimData } from '../../../claimProvider'
import globalStyles from '../../../globals/pages.module.scss'

interface StepData {
    telephone?: string
    email?: string
    [key: string]: string | undefined
}

export const ContactDetails = (props: FormPartInterface) => {
    const { saveValueFunct, isActive, assignGroup } = props
    const [currentStep, setCurrentStep] = React.useState(0)
    const [postCurrentStep, setPostCurrentStep] = React.useState(0)
    const [stepData, setStepData] = useState<StepData>({})
    const [formErrors, setFormErrors] = useState<{ [key: string]: boolean }>({})
    const [showErrors, setShowErrors] = useState(false)
    const [currentInputs, setCurrentInputs] = useState<StepData>({})
    const [validationResults, setValidationResults] = useState<{ [key: string]: boolean }>({})
    const [currentData, setCurrentData] = useState<any>({})

    const claimData = useClaimData()
    const updateClaim = useUpdateClaimData()

    // useEffect(() => {
    //     console.log('claimData from contact details', claimData)

    //     setCurrentData(claimData)
    // }, [claimData])

    useEffect(() => {
        if (isActive === 'contact') {
            setShowErrors(false)
            setFormErrors({})
        }
    }, [isActive])

    useEffect(() => {
        // console.log('claimData from contact details', claimData)
        if (claimData.telephone || claimData.email) {
            const initialData = {
                telephone: claimData.telephone || '',
                email: claimData.email || '',
            }
            setStepData(initialData)
            setCurrentInputs(initialData)
            setValidationResults({
                telephone: !!claimData.telephone,
                email: !!claimData.email,
            })
        }
        setCurrentData(claimData)
    }, [claimData])

    const preSaveValueFunct = (dataToSave: SaveValueInterface) => {
        const saved = saveValueFunct(dataToSave)
        if (saved.success) {
            setCurrentInputs((prevData: StepData) => ({
                ...prevData,
                [dataToSave.field]: dataToSave.value,
            }))
            setValidationResults((prev) => ({
                ...prev,
                [dataToSave.field]: !saved.error,
            }))
            if (dataToSave.value.trim()) {
                setFormErrors((prev) => ({
                    ...prev,
                    [dataToSave.field]: false,
                }))
            }
        } else {
            setValidationResults((prev) => ({
                ...prev,
                [dataToSave.field]: false,
            }))
        }
        return saved
    }

    const validateForm = () => {
        const newErrors: { [key: string]: boolean } = {}
        let hasErrors = false

        if (!currentInputs.telephone?.trim() || !validationResults.telephone) {
            newErrors.telephone = true
            hasErrors = true
        }

        if (!currentInputs.email?.trim() || !validationResults.email) {
            newErrors.email = true
            hasErrors = true
        }

        setFormErrors(newErrors)
        return !hasErrors
    }

    const handleNext = () => {
        setShowErrors(true)
        if (!validateForm()) {
            return
        }
        const updatedData = {
            ...claimData,
            ...currentInputs,
        }
        updateClaim(updatedData)
        assignGroup('confirm')
    }

    const getCurrentStep = () => {
        return isActive === 'contact' ? (
            <FieldGroup title="Contact Information">
                <FormCard assignPostStep={setPostCurrentStep} step={currentStep} onBack={() => assignGroup('person')}>
                    <h3>Your Contact Details</h3>
                    <p className={`${globalStyles.contactDetailsText}`}>
                        Please enter your telephone number and e-mail address so we can contact you regarding your
                        claims.
                    </p>
                    <Field extraStyle={{ padding: '0' }} fieldLabel="Telephone" labelPosition="left" enhanced={true}>
                        <InputFieldText
                            fieldName="telephone"
                            saveValue={preSaveValueFunct}
                            fieldType={'tel'}
                            populateValue={currentInputs.telephone || ''}
                            enhanced={true}
                            required={true}
                            showErrors={showErrors}
                        />
                    </Field>
                    <Field extraStyle={{ padding: '0' }} fieldLabel="Email" labelPosition="left" enhanced={true}>
                        <InputFieldText
                            fieldName="email"
                            saveValue={preSaveValueFunct}
                            fieldType={'email'}
                            populateValue={currentInputs.email || ''}
                            enhanced={true}
                            required={true}
                            showErrors={showErrors}
                        />
                    </Field>
                    {/* <Field extraStyle={{ padding: '0' }} fieldLabel="Search Address" labelPosition="left">
                        <InputFieldAddressLookup fieldName={`searchAddress`} saveValue={preSaveValueFunct} />
                    </Field>
                    {AddressText.length > 0 && (
                        <>
                            <Field extraStyle={{ padding: '0' }} fieldLabel="Address Line 1" labelPosition="left">
                                <InputFieldText
                                    fieldName="address_line_one"
                                    saveValue={preSaveValueFunct}
                                    populateValue={AddressOne}
                                />
                            </Field>
                            <Field extraStyle={{ padding: '0' }} fieldLabel="Address Line 2" labelPosition="left">
                                <InputFieldText
                                    fieldName="address_line_two"
                                    saveValue={preSaveValueFunct}
                                    populateValue={AddressTwo}
                                />
                            </Field>
                            <Field extraStyle={{ padding: '0' }} fieldLabel="Address Line 3" labelPosition="left">
                                <InputFieldText
                                    fieldName="addres_line_three"
                                    saveValue={preSaveValueFunct}
                                    populateValue={AddressThree}
                                />
                            </Field>
                            <Field extraStyle={{ padding: '0' }} fieldLabel="City" labelPosition="left">
                                <InputFieldText
                                    fieldName="city"
                                    saveValue={preSaveValueFunct}
                                    populateValue={AddressCity}
                                />
                            </Field>
                            <Field extraStyle={{ padding: '0' }} fieldLabel="Postcode" labelPosition="left">
                                <InputFieldText
                                    fieldName="postcode"
                                    saveValue={preSaveValueFunct}
                                    populateValue={AddressPostcode}
                                />
                            </Field>
                        </>
                    )} */}
                    {/* <p>
                        By clicking the button below, you confirm you give your permission for Sentinel Legal Ltd to
                        contact you by telephone, e-mail or post regarding your claim.
                    </p> */}
                    <SubmitButton
                        text="Review Details"
                        btnType="primary"
                        onClick={handleNext}
                        disabled={!validationResults.telephone || !validationResults.email}
                    />
                </FormCard>
            </FieldGroup>
        ) : (
            <></>
        )
    }

    return getCurrentStep()
}
